import React from 'react'
import Select from 'react-select'

const DropdownIndicator = ({ data }) => (
  <div className="formselect__indicator formselect__dropdown-indicator">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path
        d="M10 11.321l3.577-3.577c.326-.325.853-.325 1.179 0 .325.326.325.853 0 1.179l-4.167 4.166c-.325.326-.853.326-1.178 0L5.244 8.923c-.325-.326-.325-.853 0-1.179.326-.325.853-.325 1.179 0L10 11.321z"
        transform="translate(-136 -883) translate(136 883)"
      />
    </svg>
  </div>
)

const FormSelect = (props) => {
  const {
    id = '',
    placeholder = '',
    name = '',
    value = null,
    className = '',
    isDisabled = false,
    onBlur = () => {},
    onFocus = () => {},
    onChange = () => {},
    options = [],
    isMulti = false,
    isSearchable = false,
    isClearable = false,
    formatOptionLabel = null,
    filterOption = undefined,
    menuPortalTarget = undefined,
    menuPosition = 'absolute',
    styles = undefined,
    minMenuHeight = undefined,
  } = props

  const convertOptionToEvent = (option) => ({
    target: {
      type: 'select',
      name: name,
      value: isMulti ? (option ? option.map((opt) => opt.value) : []) : option?.value,
      label: isMulti ? (option ? option.map((opt) => opt.label) : []) : option?.label,
    },
  })

  const onLocalChange = (option) => {
    onChange(convertOptionToEvent(option))
  }

  return (
    <Select
      inputId={id}
      onBlur={onBlur}
      className={`formselect ${className}`}
      classNamePrefix="formselect"
      closeMenuOnSelect
      isClearable={isClearable || false}
      isSearchable={isSearchable || false}
      isDisabled={isDisabled || false}
      instanceId={name}
      name={name}
      placeholder={placeholder}
      components={{ DropdownIndicator }}
      onChange={onLocalChange}
      options={options}
      value={
        options?.find((option) => option.selected) ||
        options?.find((option) => option.value === value) ||
        null
      }
      formatOptionLabel={formatOptionLabel}
      filterOption={filterOption}
      menuPortalTarget={menuPortalTarget}
      menuPosition={menuPosition}
      minMenuHeight={minMenuHeight}
      styles={styles}
    />
  )
}

export default FormSelect
